
import { AxiosError, AxiosResponse } from "axios";
import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";

import AppTerms from "./AppTerms.vue";
import publicApi from "@/network/public_api";
import { Locales } from "../../i18n/locales";

@Component({
  components: {
    AppTerms,
  },
})
export default class RegistrationPage extends Vue {
  private email = "";
  private userName = "";
  private firstName = "";
  private lastName = "";
  private isEmailValid = true;
  private didRegisterSuccessfully = false;
  private message = "";
  private pinCode = "";
  private acceptedTerms = false;
  private showTerms = false;
  private isSubmitting = false;

  private eventTitle = "";
  private eventStartDate = "";
  private eventEndDate = "";
  private eventCode = "";
  private eventDomains = [];
  private showError = false;
  @Getter("errorMsg") private errorMsg!: string;
  @Getter("errorCode") private errorCode!: number;

  created() {
    if (this.eventCode) {
      return;
    }
    if (this.$route.query && this.$route.query.code) {
      publicApi
        .get("/event_by_code?code=" + this.$route.query.code)
        .then((res) => {
          this.eventCode = res.data.data.code;
          this.eventTitle = res.data.data.title;
          this.eventStartDate = res.data.data.startDate;
          this.eventEndDate = res.data.data.endDate;
          this.eventDomains = res.data.data.domains;
        })
        .catch((error: AxiosError) => {
          this.$router.push("/login");
        });
    } else {
      this.$router.push("/login");
    }
  }

  onSubmit(event: Event) {
    if (!this.isEmailValid || this.isSubmitting) {
      event.preventDefault();
      return;
    }
    this.isSubmitting = true;
    this.showError = false;
    this.$store
      .dispatch("register", {
        username: this.userName,
        eventCode: this.eventCode,
      })
      .then((response: AxiosResponse) => {
        this.didRegisterSuccessfully = true;
        this.message = response.data.message;
        this.pinCode = response.data.pin;
        (Vue as any).$toast.success(this.message, {
          position: this.$i18n.locale === Locales.EN ? "top-right" : "top-left",
        });
      })
        .catch(() => {
            this.showError = true;
            this.didRegisterSuccessfully = false;
        })
      .finally(() => {
        this.isSubmitting = false;
      });
  }

    sanitizeInput(event) {
        this.showError = false;
        let value = event.target.value;
        value = value.replace(/[^a-zA-Z0-9 .\-_\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/g, '');
        this.userName = value;
    }


  checkEmailValidy() {
    if (this.eventDomains.length === 0 || !this.email) {
      this.isEmailValid = true;
      return;
    }
    const atIndex = this.email.indexOf("@");
    let found = false;
    if (atIndex > 0) {
      const mailDomain = this.email.substring(atIndex + 1);
      this.eventDomains.forEach((domain) => {
        if (mailDomain.toLowerCase() === domain) {
          found = true;
        }
      });
    }
    this.isEmailValid = !found;
  }

  proceesToLogin(): void {
    this.showError = false;
    this.$router.push("/login");
  }

  agreed(val: boolean) {
    this.acceptedTerms = true;
  }
}
